import { Select } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { type FilesSortOrder } from "../types/files-filters.types.ts"

interface FilesSortSelectProps {
  value: FilesSortOrder
  onChange: (value: FilesSortOrder) => void
}

export function FilesSortSelect({ value, onChange }: FilesSortSelectProps) {
  const { t } = useTranslation()

  const options: { label: string; value: FilesSortOrder }[] = [
    { label: t("files.sort.modifiedDesc"), value: "modified_desc" },
    { label: t("files.sort.addedDesc"), value: "added_desc" },
    { label: t("files.sort.documentDateDesc"), value: "document_date_desc" },
    { label: t("files.sort.documentDateAsc"), value: "document_date_asc" },
    { label: t("files.sort.nameAsc"), value: "name_asc" },
    { label: t("files.sort.nameDesc"), value: "name_desc" },
    { label: t("files.sort.sizeDesc"), value: "size_desc" },
    { label: t("files.sort.sizeAsc"), value: "size_asc" }
  ]

  return (
    <Select<FilesSortOrder>
      value={value}
      onChange={onChange}
      options={options}
      aria-label={t("files.sort.label")}
      className="w-[280px]"
      labelRender={({ label }) => <>{t("files.sort.prefix")}: {label}</>}
    />
  )
}
